import { ReactComponent as EditIcon } from "../../../../assets/img/EditPatientInfo.svg";
export const CommunicationPreferences = (props: any) => {
    const patientInfo = props.patientInfo;

    return (<>
        <div className='d-flex align-items-center'>
            <h2 className='h4 m-0'>Communication Preferences</h2>
            <a href='javascript:void(0)' className={`btn d-flex align-items-center py-1 pe-4 ms-auto`} onClick={() => props.handleOffCanvasShow("editCommunication")}>
                <EditIcon />
                <span className="d-inline-block lh-sm ms-2 border-primary border-bottom text-secondary">Edit</span>
            </a>
        </div>
        <hr />
        <div className="row g-2">
            <div className="col-12 col-md-4 col-lg-4">
                <div className="mb-2">
                    <label
                        className="form-label text-light mb-1 fs-14"
                    >
                        Language
                    </label>
                    <p className="fw-medium fs-14 mb-0">
                        {
                            props.loading ? (<span className="placeholder-wave">
                                <span className="placeholder w-80"></span>
                            </span>) : patientInfo?.preferredLanguageInfo?.type ? patientInfo?.preferredLanguageInfo?.type : '-'
                        }
                    </p>
                </div>
            </div>
            <div className="col-12 col-md-4 col-lg-4">
                <div className="mb-2">
                    <label
                        className="form-label text-light mb-1 fs-14"
                    >
                        Chat Via
                    </label>
                    <p className="fw-medium fs-14 mb-0">
                        {
                            props.loading ? (<span className="placeholder-wave">
                                <span className="placeholder w-80"></span>
                            </span>) : patientInfo?.preferredChatChannel ? patientInfo?.preferredChatChannel : '-'
                        }
                    </p>
                </div>
            </div>
            <div className="col-12 col-md-4 col-lg-4">
                <div className="mb-2">
                    <label
                        className="form-label text-light mb-1 fs-14"
                    >
                        Communication Channel
                    </label>
                    <p className="fw-medium fs-14 mb-0">
                        {
                            props.loading ? (<span className="placeholder-wave">
                                <span className="placeholder w-80"></span>
                            </span>) : patientInfo?.preferredCommunicationChannel ? patientInfo?.preferredCommunicationChannel : '-'
                        }
                    </p>
                </div>
            </div>
        </div>
    </>);
}